import type { CandidateResume } from '@entities/candidates';
import type { EntityMetadataItem } from '@shared/ui';
import dayjs from 'dayjs';

type CandidateResumeMetadata = Pick<CandidateResume, 'createdAt' | 'updatedAt'>;

const formatDateTime = (value: string) =>
  dayjs(value).format('DD.MM.YYYY, HH:mm');

export const getEntityMetadata = ({
  createdAt,
  updatedAt,
}: CandidateResumeMetadata): EntityMetadataItem[] => [
  {
    id: 'createdAt',
    label: 'Дата создания:',
    value: formatDateTime(createdAt),
  },
  {
    id: 'updatedAt',
    label: 'Дата изменения:',
    value: updatedAt ? formatDateTime(updatedAt) : '-',
  },
];
